(ns manatee.not-found
  (:require [manatee.ui.templates :as templates]
            [rothko.panel.component :refer [panel]]))

(defn container
  [{:keys [class]}]
  [:div {:class class}
   [panel {:appearance #{:primary}}
    [:h4 "Page Not Found"]]])

(def page
  {:template templates/single-column
   :main container})
